import { ListViewItem } from '@ingka/list-view';
import { getXdkWindow } from '@pcmp/xdk-types';
import { assetTypes } from '@repo/types/asset';
import { getCountryLanguage } from '@repo/utils';

import { Feature } from '@/components/feature';

import { useAssetParams } from '@/hooks/asset.hooks';

import type { AssetActionProps } from '../../asset-context-buttons.types';

const KitchenLinkListItem = ({ context }: AssetActionProps) => {
    const { assetId } = useAssetParams();

    const { country, language } = getCountryLanguage();
    const getKitchenLinkUrl = () => {
        const path = `/${country}/${language}/kitchen-checker/?orderId=${assetId}`;
        return globalThis.location.origin + path;
    };

    const analytics = getXdkWindow()?.analytics;
    if (!analytics) {
        // oxlint-disable-next-line no-console
        console.warn('Analytics unavailable for event tracking');
    }

    return (
        <ListViewItem
            title="Kitchen Checker" // no need for a translation key as this is a temporary link
            controlIcon={context === 'modal' ? 'chevronRight' : null}
            inset={context === 'dropdown'}
            emphasised={context === 'modal'}
            control="navigational"
            onClick={() => {
                const _envMap = {
                    stage: '833269760807',
                    prod: '330224160606',
                    dev: '239423187367',
                    local: '239423187367',
                };

                // oxlint-disable-next-line @typescript-eslint/consistent-type-assertions
                const env = import.meta.env.VITE_ENV as keyof typeof _envMap;

                /** Ignore linting until we migrate to XDK-types */
                // oxlint-disable-next-line @typescript-eslint/no-floating-promises
                analytics?.track('ot-frontend-kitchen-checker-click', {
                    orderId: assetId,
                    environment: env,
                });

                globalThis.open(getKitchenLinkUrl(), '_blank');
            }}
        />
    );
};

export const KitchenLinkAction = ({ type, ...props }: AssetActionProps) => {
    const { assetType } = useAssetParams();

    // enabled only for draft orders
    if (assetType !== assetTypes.draft) {
        return null;
    }

    if (type === 'button') {
        return null;
    }

    return (
        <Feature key="kitchen-link-action" configPath={['kitchenLink.enable']}>
            <KitchenLinkListItem {...props} />
        </Feature>
    );
};
